import i18n from '@/i18n/i18n'

const { t } = i18n.global

export const STATUS_TYPE = {
  DRAFT: 99,
  REQUESTED: 10,
  DOCUMENTS_CREATED: 11,
  WAITING_RETAILER_APPROVAL: 20,
  WAITING_RETAILER_PAYMENT_METHOD: 21,
  WAITING_RETAILER_PAYMENT: 22,
  COMPLETED: 23,
  REJECTED: 29,
  WAITING_DOCUMENTS_UPLOAD: 30,
  WAITING_DOCUMENTS_APPROVAL: 31,
  DOCUMENTS_APPROVED: 32,
  AD_WAITING: 40,
  AD_REJECTED: 41,
  CANCELLED: 90
}

export const STATUS_TYPE_MAP = {
  99: t('constants.tarfin_pro_quotation_status.draft'),
  10: t('constants.tarfin_pro_quotation_status.requested'),
  11: t('constants.tarfin_pro_quotation_status.documents_created'),
  20: t('constants.tarfin_pro_quotation_status.documents_created'),
  21: t('constants.tarfin_pro_quotation_status.documents_created'),
  22: t('constants.tarfin_pro_quotation_status.waiting_payment'),
  23: t('constants.tarfin_pro_quotation_status.completed'),
  29: t('constants.tarfin_pro_quotation_status.rejected'),
  30: t('constants.tarfin_pro_quotation_status.waiting_documents_upload'),
  31: t('constants.tarfin_pro_quotation_status.waiting_documents_approval'),
  32: t('constants.tarfin_pro_quotation_status.waiting_shipping'),
  40: t('constants.tarfin_pro_quotation_status.ad_waiting'),
  41: t('constants.tarfin_pro_quotation_status.concluded'),
  90: t('constants.tarfin_pro_quotation_status.cancelled')
}

export const STATUS_TYPE_OPTIONS = [
  { id: 99, text: t('constants.tarfin_pro_quotation_status.draft') },
  { id: 10, text: t('constants.tarfin_pro_quotation_status.requested') },
  { id: 20, text: t('constants.tarfin_pro_quotation_status.documents_created') },
  { id: 21, text: t('constants.tarfin_pro_quotation_status.waiting_payment_method') },
  { id: 22, text: t('constants.tarfin_pro_quotation_status.waiting_payment') },
  { id: 23, text: t('constants.tarfin_pro_quotation_status.completed') },
  { id: 29, text: t('constants.tarfin_pro_quotation_status.rejected') },
  { id: 30, text: t('constants.tarfin_pro_quotation_status.waiting_documents_upload') },
  { id: 31, text: t('constants.tarfin_pro_quotation_status.waiting_documents_approval') },
  { id: 32, text: t('constants.tarfin_pro_quotation_status.waiting_shipping') },
  { id: 40, text: t('constants.tarfin_pro_quotation_status.ad_waiting') },
  { id: 41, text: t('constants.tarfin_pro_quotation_status.concluded') },
  { id: 90, text: t('constants.tarfin_pro_quotation_status.cancelled') }
]
export const STATUS_TYPE_BADGE_MAP = {
  [STATUS_TYPE.DRAFT]: 'secondary-lighten',
  [STATUS_TYPE.REQUESTED]: 'info-lighten',
  [STATUS_TYPE.DOCUMENTS_CREATED]: 'warning-lighten',
  [STATUS_TYPE.WAITING_RETAILER_PAYMENT]: 'warning-lighten',
  [STATUS_TYPE.COMPLETED]: 'primary-lighten',
  [STATUS_TYPE.AD_WAITING]: 'info-lighten',
  [STATUS_TYPE.AD_REJECTED]: 'secondary-lighten',
  [STATUS_TYPE.WAITING_DOCUMENTS_UPLOAD]: 'warning-lighten',
  [STATUS_TYPE.WAITING_DOCUMENTS_APPROVAL]: 'info-lighten',
  [STATUS_TYPE.WAITING_RETAILER_APPROVAL]: 'warning-lighten',
  [STATUS_TYPE.WAITING_RETAILER_PAYMENT_METHOD]: 'warning-lighten',
  [STATUS_TYPE.REJECTED]: 'secondary-lighten',
  [STATUS_TYPE.DOCUMENTS_APPROVED]: 'warning-lighten',
  [STATUS_TYPE.CANCELLED]: 'secondary-lighten'
}
export const STATUS_TYPE_INFO_BADGE_MAP = {
  [STATUS_TYPE.DRAFT]: 'secondary-lighten',
  [STATUS_TYPE.REQUESTED]: 'info-lighten',
  [STATUS_TYPE.WAITING_RETAILER_APPROVAL]: 'warning-lighten',
  [STATUS_TYPE.REJECTED]: 'secondary-lighten',
  [STATUS_TYPE.CANCELLED]: 'secondary-lighten'
}
export const STATUS_TYPE_INFO_MAP = {
  [STATUS_TYPE.DRAFT]: t('constants.tarfin_pro_quotation_status.draft'),
  [STATUS_TYPE.REQUESTED]: t('constants.tarfin_pro_quotation_status.requested'),
  [STATUS_TYPE.WAITING_RETAILER_APPROVAL]: t('constants.tarfin_pro_quotation_status.waiting_response'),
  [STATUS_TYPE.REJECTED]: t('constants.tarfin_pro_quotation_status.rejected'),
  [STATUS_TYPE.CANCELLED]: t('constants.tarfin_pro_quotation_status.cancelled')
}
